/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { getMaxValue } from '../../utils/helpers/view/chartsComponentHelper';
import {
  displayEcpTableContainer,
  ecpChartPieContainer,
  getColorsLegendForDailyAndMonthlyCharts,
  getMax,
} from '../../utils/helpers/view/ecpDetailHelper';
import EcpChartsContainer from './EcpChartsComponent';
import { piezoPluvioInterface } from '../H2SParam/Interface';
import { controlPiezoList, loaderForGraphics } from '../../utils/helpers/view/detailsHelper';

interface EcpDetailBodyContainerProps {
  showTab: boolean;
  dailyData: any[];
  pluvioDailyData: any[];
  monthlyData: any[];
  pluvioMonthlyData: any[];
  pieData: any[];
  tableData: any[];
  piezoDailyData: any[];
  dataSelected: any;
  piezoCode: string;
  tabType: string;
}

const EcpDetailBodyContainer = (props: EcpDetailBodyContainerProps) => {
  // get max
  const [dailyDataMax, setDailyDataMax] = useState<any>(null);
  const [monthlyDataMax, setMonthlyDataMax] = useState<any>(null);
  const [pluvioDailyDataMax, setPluvioDailyDataMax] = useState<any>(null);
  const [piezoDailyDataMax, setPiezoDailyDataMax] = useState<any>(null);
  const [pluvioMonthlyDataMax, setPluvioMonthlyDataMax] = useState<any>(null);
  // variables for zooming buttons by tab
  const [displayDailyGraphic, setDisplayDailyGraphic] =
    useState<string>('block');
  const [displayMonthlyGraphic, setDisplayMonthlyGraphic] =
    useState<string>('block');
  const [displayDivPieAndTable, setDisplayDivPieAndTable] =
    useState<string>('inline-block');
  const [heightDivCharts, setHeightDivCharts] = useState<string>('50%');
  const [heightDivAreaAndBar, setHeightDivAreaAndBar] = useState<string>('50%');

  const piezoDataChecked = props.piezoDailyData !== null ? controlPiezoList(props.piezoDailyData, props.piezoCode) : [];

  useEffect(() => {
    if (
      props.monthlyData !== null &&
      props.pluvioMonthlyData !== null
    ) {
      props.monthlyData.length > 0 && setMonthlyDataMax(getMax(props.monthlyData));
      props.pluvioMonthlyData.length > 0 &&
        setPluvioMonthlyDataMax(getMaxValue(props.pluvioMonthlyData, 'y', 'positive'));
    }
    if (
      props.dailyData !== null &&
      props.pluvioDailyData !== null
    ) {
      props.dailyData.length > 0 && setDailyDataMax(getMax(props.dailyData));
      props.pluvioDailyData.length > 0 &&
        setPluvioDailyDataMax(getMaxValue(props.pluvioDailyData, 'y', 'positive'));
    }
    // if reload searching data, reset the zoom
    if(props.dailyData === null) {
      setHeightDivAreaAndBar('50%');
      setHeightDivCharts('50%');
      setDisplayMonthlyGraphic('block');
      setDisplayDivPieAndTable('inline-block');
      setDisplayDailyGraphic('block');
    }
  }, [props.dailyData, props.monthlyData, props.pluvioDailyData, props.pluvioMonthlyData]);

  useEffect(() => {
    if (props.piezoCode !== '' && piezoDataChecked.length > 0) {
      setPiezoDailyDataMax(getMaxValue(piezoDataChecked, 'y', 'positive'));
    }
  }, [props.piezoCode]);
  
  return (
    <>
      {props.showTab === true && (
        <div
          style={{
            width: '100%',
            height: '80vh',
            display: 'flex',
          }}
        >
          {/* first column */}
          <div
            style={{
              display: 'inline-block',
              width: heightDivAreaAndBar,
              margin: '0 10px 0 0',
            }}
          >
            {props.dailyData !== null ? (
              <EcpChartsContainer
                mode={'area'}
                sanitaryWater={props.dailyData}
                pluvioData={props.pluvioDailyData}
                pluvioMax={pluvioDailyDataMax}
                piezoData={piezoDataChecked}
                piezoMax={piezoDailyDataMax}
                dataMaxValue={dailyDataMax}
                axisYLabel='Volume (m³)'
                axisXLabel='Date'
                axisYLabelPluvio={props.dataSelected.id === 1 ? 'Pluie (mm)' : 'Hauteur (m)'}
                title='Contribution des eaux parasites et des eaux sanitaires au volume relevé'
                colorsLegend={
                  props.dailyData !== null
                    ? getColorsLegendForDailyAndMonthlyCharts(props.dailyData)
                    : []
                }
                display={displayDailyGraphic}
                height={heightDivCharts}
                handleZoomIn={() => {
                  setDisplayMonthlyGraphic('none');
                  setDisplayDivPieAndTable('none');
                  setHeightDivCharts('100%');
                  setHeightDivAreaAndBar('100%');
                }}
                handleZoomOut={() => {
                  setDisplayMonthlyGraphic('block');
                  setDisplayDivPieAndTable('inline-block');
                  setHeightDivCharts('50%');
                  setHeightDivAreaAndBar('50%');
                }}
                dataSelected={props.dataSelected}
              />
            ) : 
              loaderForGraphics('96vh', '40vh', 'loaderEcpGraphics')
            }
            {props.monthlyData !== null ? (
              <EcpChartsContainer
                mode={'bar'}
                sanitaryWater={props.monthlyData}
                pluvioData={props.pluvioMonthlyData}
                pluvioMax={pluvioMonthlyDataMax}
                dataMaxValue={monthlyDataMax}
                axisYLabel='Volume (m³)'
                axisXLabel='Date'
                axisYLabelPluvio='Pluie (mm)'
                title='Contribution des eaux parasites et des eaux sanitaires au volume relevé'
                colorsLegend={
                  props.monthlyData !== null
                    ? getColorsLegendForDailyAndMonthlyCharts(props.monthlyData)
                    : []
                }
                display={displayMonthlyGraphic}
                height={heightDivCharts}
                handleZoomIn={() => {
                  setDisplayDailyGraphic('none');
                  setDisplayDivPieAndTable('none');
                  setHeightDivCharts('100%');
                  setHeightDivAreaAndBar('100%');
                }}
                handleZoomOut={() => {
                  setDisplayDailyGraphic('block');
                  setDisplayDivPieAndTable('inline-block');
                  setHeightDivCharts('50%');
                  setHeightDivAreaAndBar('50%');
                }}
                dataSelected={piezoPluvioInterface.filter((p) => p.id === 1)[0]}
              />
            ) : 
              loaderForGraphics('96vh', '40vh', 'loaderEcpGraphics')
            }
          </div>
          {/* second column */}
          <div
            style={{
              display: displayDivPieAndTable,
              width: '50%',
              margin: '0 0 0 10px',
            }}
          >
            <div
              style={{
                height: '60%',
                borderRadius: '15px',
                boxShadow: '0 14px 14px 3px rgba(18, 26, 49, 0.05)',
                backgroundColor: 'white',
                marginBottom: '15px',
                display: 'block',
              }}
            >
              {props.pieData !== null
                ? ecpChartPieContainer(props.pieData, {
                    innerRadius: 0,
                    fontSizeGraphic: '12px',
                    fontSizeTitle: '16px',
                    colorsLegend: props.pieData.map((line: any) => line.color),
                    titlesLegend: props.pieData.map((line: any) => line.title),
                    title:
                      "% d'ECP par rapport au volume total collecté" + (props.tabType === 'limitPoint' ? " au point limite" : " au bassin de collecte"),
                  })
                : loaderForGraphics('96vh', '48vh', 'loaderEcpGraphics')}
            </div>
            <div
              style={{
                height: '40%',
                borderRadius: '15px',
                boxShadow: '0 14px 14px 3px rgba(18, 26, 49, 0.05)',
                backgroundColor: 'white',
                display: 'block',
              }}
            >
              {/* Table */}
              {props.tableData !== null
                ? displayEcpTableContainer(props.tableData)
                : loaderForGraphics('96vh', '32vh', 'loaderEcpGraphics')}
              <br />
            </div>
          </div>
        </div>
      )}
      <br />
    </>
  );
};

export default React.memo(EcpDetailBodyContainer);
